import Modal from './insightModal';
export { default as InsightDetail } from './contents/insightDetail';
export { default as InsightForm } from './contents/insightForm';
export { default as InsightList } from './contents/insightList';

export default Modal;
